import request from '@/utils/request'
const ticketURL = process.env.VUE_APP_BASE_API

export const DASHAPI = {
  // 获取工单趋势图
  getChartAggrate: (params: any) =>
    request({
      url: ticketURL + 'dashboard/chartAggrate',
      method: 'get',
      params
    }),
  getIssueTypeAggrate: (params: any) =>
    request({
      url: ticketURL + 'dashboard/issueTypeAggrate',
      method: 'get',
      params
    })
}
